import type { HelpFile } from '../../types/help'
import { IdentitiesTestIds } from '../../../testids/IdentitiesTestIds'

export const identitiesHelp: HelpFile = {
  docPage: '/docs/identity/identities',
  texts: {
    [IdentitiesTestIds.identitiesList]:
      'Every identity — the digital persona through which a person or agent is granted access.',
    [IdentitiesTestIds.btnNewUser]:
      'Create a new identity and attach it to an existing party.',
    [IdentitiesTestIds.identityRow]: null,
    [IdentitiesTestIds.colDisplayName]: null,
    [IdentitiesTestIds.colType]:
      'Identity class: EMPLOYEE, EXTERNAL, SERVICE, or AGENT.',
    [IdentitiesTestIds.colLifecycleState]:
      'Lifecycle phase: ACTIVE, INACTIVE, or TERMINATED.',
    [IdentitiesTestIds.colEntryDate]:
      'Start of access — typically employment or contract start.',
    [IdentitiesTestIds.colExitDate]:
      'End of access — typically employment or contract end.',
    [IdentitiesTestIds.colCreatedAt]: null,
  },
}
